import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-agency-questions',
  templateUrl: './agency-questions.component.html',
  styleUrl: './agency-questions.component.css'
})
export class AgencyQuestionsComponent {
  @Input() disableAfterReview: boolean = false;
  
  parentCol = "text-center align-middle tdHeaderBg";
  parentColAutoComplete = "tdHeaderBg position-relative";
  childCol = "text-center align-middle";
  childColAutoComplete = "align-middle";

  isStoreLevel: boolean = false;
  isStoreAndProductLevel : boolean = false;
  agencyQuestions : any[]= [];
  disableAgencySection: any;

  constructor(
  ) {
  }

  ngOnInit()
  {
    if(this.agencyQuestions== null || this.agencyQuestions.length==0){
      let agencyQuestion : any = [];
      agencyQuestion.agencyQuestionsID=0;
      agencyQuestion.projectID=0;
      agencyQuestion.projectFileID=null;
      agencyQuestion.storeLevel='';
      agencyQuestion.productLevel='';
      agencyQuestion.questionText='';
      agencyQuestion.isManuallyAddedNewAgencyQuestion=true;
      this.agencyQuestions.push(agencyQuestion);
    }
  }
  addAgencyQuestion() {
    if(!this.disableAgencySection)
    {
      if(!this.disableAfterReview)
      {
        this.agencyQuestions!.push({       
          projectAgencyQuestionID: 0,
          projectID: 0,
          projectFileID: null,
          storeLevel: null,
          productLevel: null,
          questionText: null,
          isManuallyAddedNewAgencyQuestion: true
        });
      }
    }
  }

  removeAgencyQuestion(index: number): void {
    if(!this.disableAgencySection)
    {
      if(!this.disableAfterReview)
      {
        if (this.agencyQuestions!.length > 1) {
          this.agencyQuestions!.splice(index, 1);    
        }
      }
    }
  }

}
